import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGift = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3.75 3.75C3.75 4.5942 4.02896 5.37325 4.49973 6H2.75C1.7835 6 1 6.7835 1 7.75V10.25C1 10.9481 1.40876 11.5507 2 11.8316V20.25C2 21.2165 2.7835 22 3.75 22H20.25C21.2165 22 22 21.2165 22 20.25V11.8316C22.5912 11.5507 23 10.9481 23 10.25V7.75C23 6.7835 22.2165 6 21.25 6H19.5003C19.971 5.37325 20.25 4.5942 20.25 3.75C20.25 1.67893 18.5711 0 16.5 0C15.0445 0 13.0642 0.90109 12 3.1101C10.9358 0.90109 8.95547 0 7.5 0C5.42893 0 3.75 1.67893 3.75 3.75ZM11.2201 6C10.9331 2.5071 8.64937 1.5 7.5 1.5C6.25736 1.5 5.25 2.50736 5.25 3.75C5.25 4.99264 6.25736 6 7.5 6H11.2201ZM20.5 12V20.25C20.5 20.3881 20.3881 20.5 20.25 20.5H12.75V12H20.5ZM11.25 20.5V12H3.5V20.25C3.5 20.3881 3.61193 20.5 3.75 20.5H11.25ZM21.25 10.5C21.3881 10.5 21.5 10.3881 21.5 10.25V7.75C21.5 7.61193 21.3881 7.5 21.25 7.5H12.75V10.5H21.25ZM2.75 10.5H11.25V7.5H2.75C2.61193 7.5 2.5 7.61193 2.5 7.75V10.25C2.5 10.3881 2.61193 10.5 2.75 10.5ZM18.75 3.75C18.75 4.99264 17.7426 6 16.5 6H12.7799C13.0669 2.5071 15.3506 1.5 16.5 1.5C17.7426 1.5 18.75 2.50736 18.75 3.75Z",
		fill: "var(--colors-grey-1)"
	})
});
export default SvgGift;
